import { render } from "./FORUM_DISPLAYED_NAME_UPDATED.vue?vue&type=template&id=533c3bdc"
import script from "./FORUM_DISPLAYED_NAME_UPDATED.vue?vue&type=script&lang=js"
export * from "./FORUM_DISPLAYED_NAME_UPDATED.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__